module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/lockedUp_2x.e1e91f4.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/lockedUp_2x.png
// module id = z4tu
// module chunks = 41